"use strict";

exports.__esModule = true;
exports.activityAttributes = void 0;
var activityAttributes = {
  argos: 'Argos',
  customerExperience: 'Customer Experience',
  event: 'Event',
  food: 'Food',
  foodServices: 'Food Services',
  gmAndClothing: 'GM & Clothing',
  groceriesOnline: 'Groceries Online',
  habitat: 'Habitat',
  lineManagers: 'Line Managers',
  nightTwilightShift: 'Night / twilight shift',
  risk: 'Risk',
  runningTheStore: 'Running the Store',
  christmas: 'Christmas',
  restricted: 'Restricted'
};
exports.activityAttributes = activityAttributes;